// In IE, NodeList (returned from querySelectorAll) doesn't support forEach.
// This converts querySelectorAll's result to an array to give us forEach.
export function findNodes (container, selector) {
  return Array.from(container.querySelectorAll(selector));
}

let TEST_DPR;
export function setDevicePixelRatio_TEST_ONLY (dpr) {
  TEST_DPR = dpr;
}
export const resetDevicePixelRatio_TEST_ONLY = setDevicePixelRatio_TEST_ONLY;
export function getDevicePixelRatio () {
  return TEST_DPR || window.devicePixelRatio;
}

const dprTracker = {};
let lastDpr;
export function onDprChange (callback) {
  const newDpr = getDevicePixelRatio();
  callback(newDpr, lastDpr);
  lastDpr = newDpr;
  if (dprTracker[newDpr]) {
    return;
  }
  dprTracker[newDpr] = true;
  const mqString = `(resolution: ${newDpr}dppx)`;
  const mq = window.matchMedia(mqString);
  if (mq.addEventListener) {
    mq.addEventListener('change', () => onDprChange(callback));
  } else if (mq.addListener) {
    // `addListener` API is deprecated; only here for IE support.
    mq.addListener(() => onDprChange(callback));
  }
}

export function delegate (target, event, filter, callback) {
  target.addEventListener(event, (e) => {
    const children = findNodes(target, filter);
    const path = getEventPath(e);
    const matchFound = !!children.find(c => path.includes(c));
    if (matchFound) {
      callback(e);
    }
  });
}

export function getEventPath (e) {
  if (e.path) {
    return e.path;
  }

  const path = [];
  let node = e.target;
  while (node && node !== document.body) {
    path.push(node);
    node = node.parentNode;
  }
  return path;
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/utility/dom-helpers.js